import {Component, EventEmitter, Input, OnInit, Output} from "@angular/core";
import {toastrService} from "../../../../../services/ux/toastr.service";
import {HttpErrorResponse} from "@angular/common/http";
import {OneAddonPlansList} from "../../../../../models/SearchService/one-offer.model";
import {OneHttpClientService} from "../../../../../data/one-http-client.service";
import { TranslateService } from "@ngx-translate/core";

@Component({
    selector: "app-one-list-of-offers",
    templateUrl: "./one-list-of-offers.component.html",
    styleUrls: ["./one-list-of-offers.component.css"]
})
export class OneListOfOffersComponent implements OnInit {

    @Input() mobileNumber: string;
    @Output() switchScreenEmitter = new EventEmitter<number>();


    offers = [];
    loading: boolean = false;

    showedOffers: OneAddonPlansList[] | null;

    constructor(
      private oneHttpClient: OneHttpClientService,
      private toastr: toastrService,
      private translateService: TranslateService
    ) {}

    // region pagination
    numberOfDots = [];

    currentIndex = 0;

    // endregion


    ngOnInit() {
        this.getOffers();
    }

    activateOffer(offer: OneAddonPlansList) {
        this.loading = true
        this.oneHttpClient.activateOffer(this.mobileNumber, offer).subscribe(
            {
                next: () => {
                    this.toastr.success(this.translateService.instant("Services.OfferActivated"));

                    // * Reload page to one path when toastr timer ends
                    setTimeout(() => {
                        window.location.pathname = "/services/one";
                    }, 3500);
                    this.loading = false
                },
                error: (err: HttpErrorResponse) => {
                    this.toastr.warning(this.translateService.instant("Services.BidActivationFailed"));
                    this.loading = false
                }
            }
        );
    }

    getOffers() {
        this.loading = true
        this.oneHttpClient
            .searchOffers(this.mobileNumber)
            .subscribe(
                {
                    next: offers => {
                        this.numberOfDots = Array(this.calculateDots(offers.length));
                        this.arrange(offers);
                        this.loading = false
                    },
                    error: () => {
                        this.toastr.warning(this.translateService.instant("Services.ReceivingBidProblem"));
                        this.loading = false
                    }
                }
            );
    }

    calculateDots(numberOfOffers: number): number {
        return Math.ceil(numberOfOffers / 8);
    }

    arrange(offers: any[]) {
        for (let i = 0; i < this.numberOfDots.length; i++) {
            this.offers.push(offers.splice(0, 8));
        }

        this.showedOffers = this.offers[0];
    }

    switchPage(index: number) {

        if (this.currentIndex === index) {
            return;
        }

        this.currentIndex = index;
        this.showedOffers = this.offers[index];
    }

    previousPage() {
        if (this.currentIndex === 0) {
            return;
        }
        this.currentIndex -= 1;
        this.showedOffers = this.offers[this.currentIndex];
    }

    nextPage() {
        if (this.currentIndex === this.numberOfDots.length - 1) {
            return;
        }
        this.currentIndex += 1;
        this.showedOffers = this.offers[this.currentIndex];
    }

    onBack() {
        this.switchScreenEmitter.emit(1);
    }

    numberTransfrom(value: string) {
        return parseInt(value) || 0
    }
}
